import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import React from "react";

export default (props: SvgIconProps) => <SvgIcon {...props}>
  <svg viewBox="-1 0 386 386.048">
    <path d="m384.023438 316.230469v-246.40625l-192-69.824219-192.0000005 69.816406v246.414063l192.0000005 69.816406zm-32-22.414063-144 52.367188v-173.953125l144-52.359375zm-160-259.769531 151.183593 54.976563-151.183593 54.976562-151.183594-54.976562zm-160 198.976563v-113.160157l144 52.359375v173.953125l-144-52.367187zm0 0" />
  </svg>
</SvgIcon>
